import { describe, expect,it } from 'vitest';

import { CARD_CATEGORIES } from '../../../../../../../shared/cardConfig/constants';
import { BILL_TO_ADDRESS_FIELDS } from '../../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../../utils/constants';
import { Card, Page } from '..';
import pages from '..';

describe('BillTo Page Template Config', () => {
  it('exports one page', () => {
    expect(Array.isArray(pages)).toBe(true);
    expect(pages).toHaveLength(1);
  });

  const billToPage = (pages as Page[]).find(
    (p) => p.route === PAGE_ROUTES.company
  ) as Page;

  describe('BillTo Page Structure', () => {
    it('has correct route', () => {
      expect(billToPage.route).toBe(PAGE_ROUTES.company);
    });

    it('contains cards array', () => {
      expect(Array.isArray(billToPage.cards)).toBe(true);
      expect(billToPage.cards.length).toBe(4);
    });
  });

  describe('Card Validations', () => {
    it('contains billTo card with hideSameAs true', () => {
      const billToCard = billToPage.cards.find(
        (c) => c.key === CARD_CATEGORIES.billTo
      ) as Card;

      expect(billToCard).toBeDefined();
      expect(billToCard.hideSameAs).toBe(true);
      expect(billToCard.fields).toHaveLength(1);
      expect(billToCard.fields?.[0].key).toBe(
        BILL_TO_ADDRESS_FIELDS.address
      );
    });

    it('contains invoiceDelivery card with correct fieldWrapper', () => {
      const invoiceCard = billToPage.cards.find(
        (c) => c.key === CARD_CATEGORIES.invoiceDelivery
      ) as Card;

      expect(invoiceCard).toBeDefined();
      expect(invoiceCard.fieldWrapper).toContain('[0]');
      expect(invoiceCard.fields?.length).toBe(2);
    });

    it('contains additionalAttachmentCard', () => {
      const attachmentCard = billToPage.cards.find(
        (c) => c.key === CARD_CATEGORIES.additionalAttachmentCard
      ) as Card;

      expect(attachmentCard).toBeDefined();
      expect(attachmentCard.fields).toHaveLength(1);
    });

    it('contains privacyPolicy card without fields', () => {
      const privacyCard = billToPage.cards.find(
        (c) => c.key === CARD_CATEGORIES.privacyPolicy
      ) as Card;

      expect(privacyCard).toBeDefined();
      expect(privacyCard.fields).toBeUndefined();
    });
  });
});